import { EntityStatus, ItemStatus } from '../interfaces/views.interface';
import { AccountStatus } from '../swagger-api';

export function getStatusBadgeStyle(status: EntityStatus): string {
  switch (status) {
    case ItemStatus.EXPIRED:
      return 'expired-badge';
    case ItemStatus.BLOCKED:
      return 'blocked-badge';
    case ItemStatus.DELETED:
      return 'deleted-badge';
    case ItemStatus.PRIVATE:
      return 'private-badge';
    case AccountStatus.DEACTIVATED:
      return 'deactivated-badge';
    default:
      return '';
  }
}

export function getStatusMark(status: EntityStatus): string {
  switch (status) {
    case ItemStatus.EXPIRED:
      return 'EXPIRED_MARK';
    case ItemStatus.BLOCKED:
      return 'BLOCKED_MARK';
    case ItemStatus.PRIVATE:
      return 'PRIVATE_MARK';
    case AccountStatus.DEACTIVATED:
      return 'DEACTIVATED_MARK';
    default:
      return '';
  }
}
